import { extractDataAxios, extractErrorMessageAxios, extractValidationErrorsAxios } from "@/httpClient";
import { createNamespacedHelpers } from "vuex";

const vehicles = {
  namespaced: true,
  state: () => ({
    isFetchedOnce: false,
    data: [],
    isLoading: false,
    // use 'error' and 'validationErrors' together in components, e.g. check 'error' for null then only try to show 'validationErrors'
    error: null,
    validationErrors: [],
    isBeingDeletedId: null,
    years: [],
    selectedYear: null,
    makes: [],
    selectedMake: null,
    models: [],
    selectedModel: null,
    engineSizes: [],
    selectedEngineSize: null,
    pageNumber: 1
  }),

  getters: {
    filteredItems: (state) => {
      if (state.selectedEngineSize) {
        return state.data.filter(vehicle => vehicle.year === state.selectedYear &&
          vehicle.make === state.selectedMake &&
          vehicle.model === state.selectedModel &&
          vehicle.engineSize === state.engineSize)
      }
      return state.data;
    },
  },

  mutations: {
    SET_PAGE_NUMBER(state, pageNumber) {
      state.pageNumber = pageNumber;
    },
    FETCH_BEGIN(state) {
      state.isLoading = true;
      state.error = null;
    },

    FETCH_SUCCESS(state, payload) {
      state.isFetchedOnce = true;
      state.isLoading = false;
      state.data = payload;
      let years = payload.map(vehicle => vehicle.year);
      // get unique values
      years = [...new Set(years)].sort();
      state.years = years;
    },

    FETCH_ERROR(state, error) {
      state.isLoading = false;
      state.error = error;
    },

    // FILTER_BY_MANUFACTURER(state, manufacturer) {
    //   state.filtered = state.data.filter(converter => {
    //     return converter.manufacturer === manufacturer
    //   });
    // },

    // FILTER_BY_CODE_OR_GRADE_NAME(state, codeOrGradeName) {
    //   state.filtered = [state.data.find(converter => converter.code === codeOrGradeName)];
    // },

    ADD(state, payload) {
      state.data = [payload, ...state.data];
    },

    EDIT(state, payload) {
      state.data.forEach((converter, index) => {
        if (converter.id === payload.id) {
          state.data[index] = payload;
        }
      });
    },

    DELETE_BEGIN(state, id) {
      state.isBeingDeletedId = id
    },

    DELETE_SUCCESS(state) {
      state.data = state.data.filter(converter => converter.id !== state.isBeingDeletedId);
      state.isBeingDeletedId = null;
    },

    DELETE_ERROR(state, error) {
      state.isBeingDeletedId = null;
      const errorToShow = 'Failed to delete the Vehicle. ' + error;
      // TODO: add the error here to global snackbar queue
    },
    SET_SELECTED_YEAR(state, year) {
      state.selectedYear = year;
      state.selectedMake = null;
      state.selectedModel = null;
      state.selectedEngineSize = null;
      const makes = [...new Set(state.data.filter(vehicle => vehicle.year === year).map(vehicle => vehicle.make))].sort();
      state.makes = makes;
    },
    SET_SELECTED_MAKE(state, make) {
      state.selectedMake = make;
      state.selectedModel = null;
      state.selectedEngineSize = null;
      const models = [...new Set(state.data.filter(vehicle => vehicle.year === state.selectedYear && vehicle.make === make).map(vehicle => vehicle.model))].sort();
      state.models = models;
    },
    SET_SELECTED_MODEL(state, model) {
      state.selectedModel = model;
      state.selectedEngineSize = null;
      const engineSizes = [...new Set(state.data.filter(vehicle => vehicle.year === state.selectedYear && vehicle.make === state.selectedMake && vehicle.model === model).map(vehicle => vehicle.engine_size))].sort();
      state.engineSizes = engineSizes;
    },
    SET_SELECTED_ENGINE_SIZE(state, engineSize) {
      state.selectedEngineSize = engineSize;
    },
    CLEAR_SEARCH(state) {
      state.selectedYear = null;
      state.selectedMake = null;
      state.selectedModel = null;
      state.selectedEngineSize = null;
    }
  },

  actions: {
    async fetch({ commit }) {
      commit('FETCH_BEGIN');
      try {
        const data = extractDataAxios(await window.axios.get('/api/vehicles'));
        if (data) {
          commit('FETCH_SUCCESS', data);
        }
      }
      catch (e) {
        console.error(e);
        commit('FETCH_ERROR', extractErrorMessageAxios(e));
      }
    },

    async delete({ commit }, id) {
      commit('DELETE_BEGIN', id);
      try {
        await window.axios.delete('/api/vehicles/' + id);
        commit('DELETE_SUCCESS');
      }
      catch (e) {
        console.error(e);
        commit('DELETE_ERROR', extractErrorMessageAxios(e));
      }
    },

    selectYear({ commit }, year) {
      commit('SET_SELECTED_YEAR', year);
    },
    selectMake({ commit }, make) {
      commit('SET_SELECTED_MAKE', make);
    },
    selectModel({ commit }, model) {
      commit('SET_SELECTED_MODEL', model);
    },
    selectEngineSize({ commit }, engineSize) {
      commit('SET_SELECTED_ENGINE_SIZE', engineSize);
    },
    clearSearch({commit}) {
      commit('CLEAR_SEARCH');
    }
  },
}

const { mapState, mapActions, mapMutations, mapGetters } = createNamespacedHelpers('vehicles');

export { mapState, mapActions, mapMutations, mapGetters };

export default vehicles;